import React from 'react'
import styles from './BrideImage.module.scss'

function BrideImage({ srcOne, srcTwo }) {
	return (
		<div className={styles.brideGroup}>
			<figure>
				<img src={srcOne} alt="bride1" />
			</figure>
			<figure>
				<img src={srcTwo} alt="bride2" />
			</figure>
		</div>
	)
}

export default BrideImage
